import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import btnGoogle from '../../../assets/images/top/btnGoogle/web_light_sq_SI@4x.png';
import btnMicrosoft from '../../../assets/images/top/btnMicrosoft/ms-symbollockup_mssymbol_19.svg';
import { saveLoginInfoToStorage } from '../../../utils/loginInfo';

function Signin(): ReactElement {
    const { t } = useTranslation('login');

    const handleGoogleAuth = (): void => {
        saveLoginInfoToStorage();
        window.location.href = '/oauth2/authorization/google';
    };

    const handleMicrosoftAuth = (): void => {
        saveLoginInfoToStorage();
        window.location.href = '/oauth2/authorization/azure';
    };

    return (
        <div className="bg-gray-700/70 py-14 w-11/12 xl:w-1/2 rounded-3xl flex flex-col justify-center text-center gap-6 my-28">
            <p className="text-gray-50">{t('signin.google.caption')}</p>
            <a
                href="/oauth2/authorization/google"
                className="h-20 mx-auto px-4 hover:opacity-80"
                onClick={(e) => {
                    e.preventDefault();
                    handleGoogleAuth();
                }}
            >
                <img src={btnGoogle} alt="Google" aria-hidden="true" className="h-20" />
            </a>

            <p className="text-gray-50 mt-10">{t('signin.microsoft.caption')}</p>
            <button
                type="button"
                onClick={handleMicrosoftAuth}
                className="flex items-center justify-center h-20 xl:w-full min-w-[200px] max-w-[350px] mx-4 md:mx-auto rounded-lg border-2 text-gray-800 border-gray-500 bg-white transition hover:opacity-80"
            >
                <img src={btnMicrosoft} alt="Microsoft" className="w-9 h-9 mr-3" aria-hidden="true" />
                <span className="text-2xl font-semibold font-sans tracking-wider">
                    {t('signin.microsoft.button')}
                </span>
            </button>
        </div>
    );
}

export default Signin;
